// OAuth Mercado Livre para Contas Sociais.
//
// Irmao de metaOAuth.js, mas com uma diferenca importante: aqui o front NAO monta
// a URL de autorizacao. Ele pede a URL pronta ao backend, porque:
//   - o `state` e assinado (HMAC + expiracao). O fluxo do Meta manda
//     `mkt_<clienteId>` em texto puro, o que em tese permite forjar o callback e
//     vincular uma conta ao tenant errado — nao repetimos isso aqui;
//   - o `code_verifier` do PKCE fica no Redis do backend, nunca no navegador.
//
// Por isso este arquivo e bem menor que metaOAuth.js: nao ha grupos de escopo a
// declarar (o Mercado Livre concede tudo que o app pede, sem App Review por
// escopo) nem app secundario.

import mktAccountsService from '../../../../services/mktAccountsService';

export const ML_OAUTH_RETURN_KEY = 'ml_oauth_return';

/**
 * Abre o dialogo de autorizacao do Mercado Livre.
 *
 * @param {string} clienteId
 * @param {{ returnTo?: string }} [opts] — rota para voltar apos o redirect do webhook
 */
export async function abrirMercadoLivreOAuth(clienteId, opts = {}) {
    if (opts.returnTo) {
        try {
            sessionStorage.setItem(ML_OAUTH_RETURN_KEY, opts.returnTo);
        } catch (_) { /* private mode */ }
    }

    const resposta = await mktAccountsService.iniciarOAuthMercadoLivre(clienteId);
    const authUrl = resposta?.data?.auth_url;
    if (!authUrl) {
        throw new Error(resposta?.message || 'Não foi possível iniciar a conexão com o Mercado Livre');
    }

    window.location.assign(authUrl);
}

export function consumeMercadoLivreReturnPath() {
    try {
        const path = sessionStorage.getItem(ML_OAUTH_RETURN_KEY);
        sessionStorage.removeItem(ML_OAUTH_RETURN_KEY);
        return path || null;
    } catch (_) {
        return null;
    }
}
